import { createApp } from 'vue'
import Ohm from './Ohm.vue'
import './assets/global.css'

createApp(Ohm).mount('#ohm')
